import React, { Component } from "react"
import Caption from "./caption"
import classNames from 'classnames'

class AudioP extends Component {
  constructor(props) {
    super(props)

    this.state = {
      playing: false,
      current: 0,
    }

    this.player = React.createRef()
  }

  componentDidMount() {
    this.interval = setInterval(this.timeupdate.bind(this), 100)
  }

  componentWillUnmount() {
    clearInterval(this.interval)
  }

  timeupdate = () => {
    this.setState({ current: this.player.current.currentTime })
  }

  play = e => {
    e.preventDefault();
    this.player.current.play();
  }

  pause = e => {
    e.preventDefault();
    this.player.current.pause();
  }

  toggle = e => {
    e.preventDefault()

    const { playing } = this.state

    if (playing) {
      this.pause(e)
    } else {
      this.play(e)
    }

    this.setState({ playing: !playing })
  }

  getPlaybackTime = () => {
    const time = this.state.current
    const duration = this.player.current.duration

    var formattedNumber = z => ("0" + z).slice(-2)

    const minutes = t => {
      let time = Math.floor(t / 60)

      if (time > 59) {
        time = Math.floor(t / 60) - 60;
      }

      return time
    }


    const seconds = t => {
      const min = minutes(t)
      let time = Math.round(t - min * 60);

      if (time > 3599) {
        time = Math.round(t - min * 60) - 3600;
      }

      return time
    }

    const current = `${formattedNumber(minutes(time))}:${formattedNumber(seconds(time))}`
    const total = `${formattedNumber(minutes(duration))}:${formattedNumber(seconds(duration))}`

    return `${current} / ${total}`;
  }

  render() {
    return (
      <div className="audio">
        <button className={classNames('audio__button', { active: this.state.playing })} onClick={this.toggle}>
        </button>
        <div className="audio__time" onClick={() => this.player.current.currentTime = 0}>{this.player.current && this.getPlaybackTime()}</div>
        <audio className="audio__player" preload="false" ref={this.player}>
          <source src={this.props.src} />
        </audio>
      </div>
    )
  }
}

class Sound extends Component {
  render() {
    const { caption, src } = this.props

    return (
      <div className="sound">
        <div className="sound__player">
          <AudioP src={src} />
        </div>
        <div className="sound__caption">
          <Caption {...caption} />
        </div>
      </div>
    )
  }
}

export default Sound
